export const exportPrintArticle = {
    id: 'export-print-module',
    title: 'Печать и экспорт в PDF/SVG',
    category: 'Модули',
    requiredModule: 'printing',
    summary: 'Формирование картографических планшетов высокой четкости.',
    markdown: `
## Модуль печати и экспорта PDF/SVG

Инструмент профессиональной подготовки схем и генеральных планов к печати в векторном и растровом виде.

### Возможности модуля:
- **Векторный экспорт в SVG:** сохранение идеальной четкости линий и шрифтов при любом увеличении.
- **Многостраничный PDF:** компоновка альбомов и отчетов по объектам.
- **Настройка надписей:** позиционирование номеров участков, литеров зданий и легенды.
`
};
